var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('navbar',{attrs:{"bar-title":"所有日志"}}),_c('logs',{ref:"lgs",staticStyle:{"margin":"55px 0 56px 0"},attrs:{"logs-data":_vm.logsData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }